/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseGetTransportationOptions,
} from '../models/index';
import {
    ResponseGetTransportationOptionsFromJSON,
    ResponseGetTransportationOptionsToJSON,
} from '../models/index';

/**
 * 
 */
export class TransportationOptionsApi extends runtime.BaseAPI {

    /**
     * ステータス一覧を取得
     * ステータス一覧を取得
     */
    async transportationOptionsGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetTransportationOptions>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/transportationOptions/getAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetTransportationOptionsFromJSON));
    }

    /**
     * ステータス一覧を取得
     * ステータス一覧を取得
     */
    async transportationOptionsGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetTransportationOptions>> {
        const response = await this.transportationOptionsGetAllGetRaw(initOverrides);
        return await response.value();
    }

}
